import {AfterViewInit, Component, ElementRef, Inject, OnInit, ViewChild} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material';
import {FormBuilder, FormGroup} from '@angular/forms';

@Component({
    selector: 'app-export-modal',
    templateUrl: './export-modal.component.html',
    styleUrls: ['./export-modal.component.scss'],
    preserveWhitespaces: true
})
export class ExportModalComponent implements OnInit, AfterViewInit {
    cols: any[];
    items: any[];

    private mode = 10;
    public modeEnabled = false;
    public screenTitle = '';
    private modeOptions = [
        {value: 10, label: 'Current page data'},
        {value: 20, label: 'All data'}
    ];

    private dialogContentHeight = '0px';

    @ViewChild('exportModal') exportModal: ElementRef;
    @ViewChild('header') header: ElementRef;
    @ViewChild('formContainer') formContainer: ElementRef;
    @ViewChild('content') content: ElementRef;
    @ViewChild('footer') footer: ElementRef;

    form: FormGroup;
    columns: any;

    constructor(
        @Inject(MAT_DIALOG_DATA) public data: any,
        public dialogRef: MatDialogRef<ExportModalComponent>,
        private formBuilder: FormBuilder
    ) {
    }

    ngOnInit() {
        this.cols = this.data['cols'].filter(col => col['export']['visible']);
        this.modeEnabled = Number(this.data['modeEnabled']) === 1;
        this.screenTitle = this.data.hasOwnProperty('screenTitle') ? this.data['screenTitle'].toString().trim() : '';
        this.form = this.formBuilder.group({
            checkboxes: this.buildColumns(),
            mode: this.mode
        });
    }

    ngAfterViewInit() {
        setTimeout(() => this.dialogContentHeight = this.getContentDialogHeight() + 'px', 0);
    }

    get checkboxes() {
        return this.form.get('checkboxes');
    };

    buildColumns() {
        const arr = this.cols.map(col => {
            return this.formBuilder.control(col['export']['checked']);
        });

        return this.formBuilder.array(arr);
    }

    getContentDialogHeight(): number {
        return (this.exportModal.nativeElement.offsetHeight) -
            (this.header.nativeElement.offsetHeight + this.footer.nativeElement.offsetHeight + 2);
    }

    closeDialog(value) {
        this.dialogRef.close(value);
    }

    submit(form) {
        const formValue = Object.assign({}, {
            columns: form.checkboxes.map((selected, i) => {
                return {
                    id: this.cols[i].field, selected: selected
                }
            }).filter(v => v.selected === true)
        });
        const cols = [];
        formValue.columns.forEach(col => {
            cols.push(col['id']);
        });
        const mode = form.mode;
        this.closeDialog({
            mode: mode,
            columns: cols
        });
    }

}



// WEBPACK FOOTER //
// /home/ubuntu/edi/angular/app/components/export-modal/export-modal.component.ts